import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import config from './config';

config.load().then(() => ReactDOM.createRoot(document.getElementById('root')).render(<App />));
